import { env } from "@/env";
import GADConfig from "../google-automated-discount";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const ngDkFiMerchant = "5557157768";

const denmark: MarketConfiguration = {
  code: MarketEnum.dk,
  label: "Denmark",
  descriptiveLabel: "Danish",
  contentfulLocale: ContentfulEnum.dk,
  contentfulCountry: "Denmark",
  locale: LocaleEnum.dk,
  serviceLocale: ServiceLocaleEnum.dk,
  language: {
    code: "da",
    label: "Danish",
    flag: "dk",
  },
  currency: CurrencyEnum.dkk,
  link: "https://www.no-ga.com/dk",
  termsSlug: "kobsbetingelser-online",
  loop54Market: MarketEnum.dk,
  adyenMarket: MarketEnum.dk,
  elevateMarket: ElevateMarketEnum.dk,
  freeShippingThreshold: 1000,
  freeShippingEnabled: false,
  externalStoreId: "ecom-dk",
  searchPathName: "sogning",
  adyenCheckoutEnabled: false,
  walleyB2CStoreId: env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_DK,
  walleyB2BStoreId: env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_DK,
  walleyChannelBaseB2B: "ng-dk-b2b",
  walleyChannelBaseB2C: "ng-dk-b2c",
  walleyCheckoutEnabled: true,
  walleyWidgetEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.nordics,
  intraRegionOrder: 2,
  googleAutomatedDiscounts: {
    allowedInTest: {
      allowedMerchants: new Set([ngDkFiMerchant, GADConfig.testMerchantId]),
      allowedPublicKeys: [
        GADConfig.testPublicKey,
        GADConfig.googleProductionPublicKey,
      ],
    },
    allowedInProd: {
      allowedMerchants: new Set([ngDkFiMerchant]),
      allowedPublicKeys: [GADConfig.googleProductionPublicKey],
    },
  },
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
  eurobonus: true,
  eurobonusThreshold: 5000,
};

export default denmark;
